import { Box, Typography } from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import theme from 'lib/theme'
import React from 'react'
import { PickingStatus, Product } from 'types/model/product'
import { pickingStatusInfo } from './utils'
import { PickingStatusWrapper } from './OrderProduct.styled'

export const PickingStatusColumn = ({ product }: { product: Product }) => {
  const { fill, status } = pickingStatusInfo(product.pickingStatus)

  if (product.productType) return <Box />
  return (
    <Box>
      <PickingStatusWrapper>
        <CircleIcon sx={{ fill, '&:hover': { fill } }} fontSize='small' />
        <Typography ml={1}>{status}</Typography>
      </PickingStatusWrapper>
      {product.pickingStatus === PickingStatus.SUBSTITUTED && (
        <Box
          sx={{
            height: theme.spacing(9),
          }}
        />
      )}
    </Box>
  )
}
